export const getExternalPage = (page: string, template?: string) => template?.split("##PAGE##").join(page)
